import * as React from 'react';
import './pdf.component.css';

const extractUrl = (fullUrl) => {
  try {
    const urlPattern = /chrome-extension:\/\/[^\/]+\/(.*)/;
    const match = fullUrl.match(urlPattern);
    return match ? match[1] : fullUrl;
  } catch (error) {
    console.error('Error extracting URL:', error);
    return null;
  }
};

const PdfViewer = ({ documentPath }) => {
  const actualUrl = extractUrl(documentPath);

  if (!actualUrl) {
    return <div className="error">Invalid document URL</div>;
  }

  return (
    <div id="container">
      <iframe
        src={actualUrl}
        className="pdfIframe"
        title="PDF Viewer"
        frameBorder="0"
        allowFullScreen
      />
      <button
        className="cta"
        onClick={() => window.open(actualUrl, '_blank')}
      >
        <span>Open in New Tab</span>
        <svg width="15px" height="10px" viewBox="0 0 13 10">
          <path d="M1,5 L11,5" />
          <polyline points="8 1 12 5 8 9" />
        </svg>
      </button>
    </div>
    
  );
};

export default PdfViewer;